export enum AuthFromTypeEnum {
  LOGIN = 'Login',
  CHANGE_PASSWORD = 'ChangePassword'
}
